module.exports = __webpack_public_path__ + "img/146.7.089c959e.png";